export default "__VITE_ASSET__C32TevT___"